import {
  END_RESEQUENCING_FLOW,
  INITIALIZE_RESEQUENCING_FLOW,
  SET_ACTIVE_DATE,
} from './actionTypes';

export const initialResequencingState = {
  startDate: null,
  endDate: null,
  activeDate: null,
  isResequencingFlowActive: false,
};

export default function resequencingReducer(
  state = initialResequencingState,
  action,
) {
  switch (action.type) {
    case INITIALIZE_RESEQUENCING_FLOW:
      return {
        ...state,
        isResequencingFlowActive: true,
        startDate: action.startDate,
        endDate: action.endDate,
      };

    case END_RESEQUENCING_FLOW:
      return initialResequencingState;

    case SET_ACTIVE_DATE:
      return { ...state, activeDate: action.activeDate };
    default:
      return state;
  }
}
